import { render } from "./ButtonToggle.vue?vue&type=template&id=477bde46&scoped=true"
import script from "./ButtonToggle.vue?vue&type=script&lang=js"
export * from "./ButtonToggle.vue?vue&type=script&lang=js"

import "./ButtonToggle.vue?vue&type=style&index=0&id=477bde46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477bde46"]])

export default __exports__